import React from 'react';
import '../Styles/Header.css';

const Header = function () {
  return (
    <header><h1 className='mainTitle'>
      Portfolio Icon Maker
      </h1></header>
  );
};

export default Header;
